import { render } from "./StudentGroupsListContentsOf.vue?vue&type=template&id=f775e01c&scoped=true"
import script from "./StudentGroupsListContentsOf.vue?vue&type=script&lang=js"
export * from "./StudentGroupsListContentsOf.vue?vue&type=script&lang=js"

import "./StudentGroupsListContentsOf.vue?vue&type=style&index=0&id=f775e01c&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f775e01c"]])

export default __exports__